import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'aphrodite'
import { Link } from 'react-router-dom'
import { Row, Col } from 'reactstrap'

import style from './style'

export const Pagination = props => {
  const itemOptions = {
    baseUrl: `${props.baseUrl}${props.queryString ? `?page=` : `/`}`,
    currentPage: props.currentPage
  }

  return (
    <Row>
      <Col>
        <ul
          className={`d-flex align-items-center justify-content-center ${css(
            style.list.list
          )}`}
        >
          <ListItem {...itemOptions} page={Math.max(props.currentPage - 2, 1)}>
            <i className={`fa fa-angle-double-left`} />
          </ListItem>
          {Array.from(Array(props.maxPage).keys())
            .slice(
              Math.max(0, props.currentPage - 2),
              Math.min(props.maxPage, props.currentPage + 1)
            )
            .map(pageId => (
              <ListItem key={pageId + 1} {...itemOptions} page={pageId + 1} />
            ))}
          <ListItem
            {...itemOptions}
            page={Math.min(props.maxPage, props.currentPage + 2)}
          >
            <i className={`fa fa-angle-double-right`} />
          </ListItem>
        </ul>
      </Col>
    </Row>
  )
}

const ListItem = props => (
  <li>
    <Link
      to={`${props.baseUrl}${props.page}`.replace('//', '/')}
      className={`d-block ${css(
        style.list.listItemLink,
        props.page === props.currentPage ? style.list.listItemLinkActive : null
      )}`}
    >
      {(props.children && props.children) || <span>{props.page}</span>}
    </Link>
  </li>
)

Pagination.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  currentPage: PropTypes.number.isRequired,
  maxPage: PropTypes.number.isRequired,
  queryString: PropTypes.bool
}

export default Pagination



// WEBPACK FOOTER //
// ./src/components/partials/Pagination/index.js